export default __webpack_public_path__ + "static/hq1-06998e8010500669de49c82bf4c40818.jpg";